import { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from '../../../types/default-cloud-graph-design-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { FigmaIcon, FigmaSearchResultIcon } from './icon';

export const figmaConfig: ThirdPartyConfig = {
	displayName: 'Figma',
	id: 'figma',
	resourceType: ProductResourceTypes3P.Figma,
	icon: get3PLogo(FigmaIcon, 'Figma', 'medium'),
	searchResultIcon: get3PLogo(FigmaSearchResultIcon, 'Figma', 'large'),
	integrationAri: 'ari:cloud:platform::integration/figma',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: true,
	isEnabled: () => true,
};
